import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateChartV3 = OpalApi<'UpdateChartV3', 200>

export const updateChart: UpdateChartV3 = async (args = {}) => {
  const chartId = args.params?.path.chart_id

  if (typeof chartId !== 'string') {
    throw new Error('Must supply a valid chart_id.')
  }

  const url = new URL(`/loupe/v3/charts/${chartId}`, window.location.origin)

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
